module.exports = __webpack_public_path__ + "img/mute_mic.033fa8b8.svg";